import React from "react";
import { Link } from "react-router-dom";
import { Shield } from "lucide-react";

const SaleTag = () => {
  return (
    <Link to="/klartext-check" className="absolute -top-8 -right-4 md:-right-8 z-20 group">
      {/* Äußerer Wrapper schaukelt (ohne Transition → kein Zittern) */}
      <div className="origin-top transform-gpu will-change-transform animate-swing motion-reduce:animate-none group-hover:[animation-play-state:paused]">
        {/* Innerer Wrapper: statische Schräglage + Hover-Effekt */}
        <div className="relative rotate-12 transition-transform duration-300 group-hover:rotate-6 group-hover:scale-110">
          {/* Aufhänger/Band */}
          <div className="absolute -top-5 left-1/2 w-4 h-10 bg-gradient-to-b from-foreground/60 to-foreground/90 rounded-t-full -translate-x-1/2 shadow-md" />
          <div className="absolute -top-6 left-1/2 w-6 h-4 bg-foreground/80 rounded-full -translate-x-1/2" />

          {/* Schild */}
          <div className="relative bg-gradient-to-br from-destructive to-destructive/80 text-destructive-foreground px-5 py-4 md:px-8 md:py-5 rounded-xl shadow-2xl border-2 border-destructive/50 overflow-hidden">
            {/* Glanz-Effekt */}
            <div className="absolute inset-0 bg-gradient-to-br from-destructive-foreground/20 via-transparent to-transparent pointer-events-none" />

            {/* Inhalt */}
            <div className="relative text-center">
              <div className="flex items-center justify-center gap-1 mb-1.5">
                <span className="text-xs md:text-sm font-black tracking-widest uppercase bg-destructive-foreground/15 px-3 py-1 rounded-full">
                  Gratis
                </span>
              </div>
              <div className="flex items-center justify-center gap-2 mb-1.5">
                <Shield className="h-5 w-5 md:h-6 md:w-6" />
                <span className="text-lg md:text-xl font-black tracking-tight">
                  Klartext-Check
                </span>
              </div>
              <div className="text-xs md:text-sm opacity-90 font-medium">
                Betrugs-Mails erkennen
              </div>
            </div>

            {/* Pulsierender Ring für Aufmerksamkeit */}
            <div className="absolute -inset-1 rounded-xl border-2 border-destructive-foreground/30 animate-pulse pointer-events-none" />
          </div>
        </div>
      </div>
    </Link>
  );
};

export default SaleTag;
